<template>
    <div class="linkard_item_bg">
        <img :src="linkardInfo.avatar" alt="" class="linkard_logo">
        <div class="linkard_name">{{ linkardInfo.name }}</div>
        <div class="linkard_tags">
            <div class="linkard_tags_bg" v-for="(item, index) in linkardInfo.tags">
                <span v-if="item" :key="index">{{ item }}</span>
            </div>
        </div>
        <div class="linkard_avatar">
            <el-image v-if="linkardInfo.npcAvatar" :src="linkardInfo.npcAvatar" fit="cover" />
        </div>
        <span class="linkard_path">{{ linkardQRImgUrl }}</span>
        <div class="qr_code_image_bg">
            <vue-qrcode :value="linkardQRImgUrl" :color="{}" type="image/png" :width="32" :height="32" :margin="0"
                errorCorrectionLevel="L"></vue-qrcode>
        </div>
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { GenerateQRCodeLink } from '@/utils/serviceUtils';
import { defineComponent, onMounted, ref, watch } from 'vue';
import VueQrcode from 'vue-qrcode';

export default defineComponent({
    name: 'linkardInfoItem_Small',
    props: {
        linkardInfo: {
            type: Object as () => any,
            default: () => ({
                id: '',
                url: '',
                name: '',
                avatar: '',
                npcAvatar: '',
                tags: []
            })
        },
    },
    components: {
        VueQrcode
    },
    setup(props, { emit }) {

        let linkardQRImgUrl = ref('');
        const generateQRCodeLink = (path: string) => {
            linkardQRImgUrl.value = GenerateQRCodeLink(path);
        };

        if (props.linkardInfo.url.length > 0) {
            generateQRCodeLink(props.linkardInfo.url);
        } else {
            watch(() => props.linkardInfo, (newValue, oldValue) => {
                generateQRCodeLink(newValue.url);
            });
        }

        onMounted(() => {
        });
        return {
            generateQRCodeLink,
            linkardQRImgUrl,
        };
    },
});

</script>

<style lang="less" scoped>
.linkard_item_bg {
    position: relative;
    background: url('../assets/images/linkard_item_bg.svg') no-repeat;
    width: 150px;
    height: 200px;
    background-size: cover;
    border-radius: 8px;

    .linkard_path {
        position: absolute;
        color: #f0f0f0;
        font-size: 6px;
        bottom: 20px;
        left: 50px;
    }

    .qr_code_image_bg {
        position: absolute;
        border-radius: 4px;
        left: 4px;
        bottom: 20px;
        display: flex;
        padding: 2px;
        background-color: #fff;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            // border-radius: 4px;
        }
    }

    .linkard_logo {
        width: 32px;
        height: 32px;
        border-radius: 20px;
        margin-top: 32px;
        margin-left: 26px;
        object-fit: cover;
    }

    .linkard_name {
        font-size: 8px;
        color: #fff;
        margin-left: 26px;
        font-weight: 600;
        margin-top: 3px;
        text-align: center;
    }

    .linkard_tags {
        margin-left: 14px;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .linkard_tags_bg {
            span {
                color: #f0f0f0;
                border-radius: 16px;
                border: 0.2px solid #F0F0F0;
                font-size: 5px;
                padding: 2px 4px;
                margin-left: 6px;
            }
        }
    }

    .linkard_avatar {
        width: 100px;
        height: 50px;
        border-radius: 10px 0px 0px 10px;
        background: #f0f0f0;
        position: absolute;
        right: 0;
        bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        :deep(.el-image) {
            height: 100%;
        }
    }
}
</style>